export const EDITOR_PROPERTIES_REGEXP = /{([\S]+?)}/g
